import { MultiPromptEntry } from "@/types";

export const DEFAULT_MULTIPROMPT_ENTRY: MultiPromptEntry = {
  prompt: "",
  promptJson: null,
  duration: 3,
};

export const UNSUPPORTED_BY_MODEL_TOOLTIP =
  "This field is disabled because it is not supported by the selected model.";

export const FIELD_NAMES = {
  batchSize: "batchSize",
  upscaleCreativity: "upscaleCreativity",
  dimensions: "dimensions",
  guidanceFiles: "guidanceFiles",
  guidanceScale: "guidanceScale",
  inferenceSteps: "inferenceSteps",
  prompt: "prompt",
  upscaleResemblance: "upscaleResemblance",
  scaleFactor: "scaleFactor",
  scaleFactorVideo: "scaleFactorVideo",
  seed: "seed",
  sourceImages: "sourceImages",
  sourceVideos: "sourceVideos",
  referenceVideos: "referenceVideos",
  sourceMeshes: "sourceMeshes",
  model: "model",
  modelWeight: "modelWeight",
  quadMesh: "quadMesh",
  faceLimit: "faceLimit",
  stability: "stability",
  audioSpeed: "audioSpeed",
  similarityBoost: "similarityBoost",
  styleExaggeration: "styleExaggeration",
  speakerBoost: "speakerBoost",
  audioDuration: "audioDuration",
  promptStrength: "promptStrength",
  texture: "texture",
  poseMode: "poseMode",
  textureResolution: "textureResolution",
  removeLighting: "removeLighting",
  meshDensity: "meshDensity",
  preserveUvs: "preserveUvs",
  lowPoly: "lowPoly",
  generateParts: "generateParts",
  pbrMaterials: "pbrMaterials",
  enableRigging: "enableRigging",
  enableAnimation: "enableAnimation",
  firstFrame: "firstFrame",
  lastFrame: "lastFrame",
  videoDuration: "videoDuration",
  fps: "fps",
  audioTrack: "audioTrack",
  generateAudio: "generateAudio",
  keepAudio: "keepAudio",
  videoEffects: "videoEffects",
  creativity: "creativity",
  realtimeMode: "realtimeMode",
  elements: "elements",
  targetFps: "targetFps",
  references: "references",
  transparency: "transparency",
  tileability: "tileability",
  performance: "performance",
  baseShift: "baseShift",
  maxShift: "maxShift",
  modelBlends: "modelBlends",
  multiPrompt: "multiPrompt",
} as const;
